// Hook para manejar las tiendas
// Hook for managing shops

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ShopsApiAdapter, Shop } from '../adapters/ShopsApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';

export const useShops = (selectedShopId?: string) => {
  const { t } = useTranslation('homeModule');
  const shopsAdapter = new ShopsApiAdapter(apiClientWH);

  const {
    data: shopsResponse,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['shops', selectedShopId],
    queryFn: () => shopsAdapter.getShops(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  // Preparar opciones para el combobox
  const shopOptions = shopsResponse?.data
    ? [
        { label: t('filters.all_stores'), value: 'all' },
        ...shopsResponse.data.map((shop: Shop) => ({
          label: shop.name,
          value: shop.id.toString(),
        })),
      ]
    : [{ label: t('filters.all_stores'), value: 'all' }];

  return {
    shops: shopsResponse?.data || [],
    shopOptions,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
